import React, { useMemo } from "react";
import { isNumber } from "lodash";

import ExecutorReport from "../../../../../../../../../../services/ExecutorReport";
import Language from "../../../../../../../../../../services/Language";
import formatNumber from "../../../../../../../../../../utils/formatNumber";
import { CellContentRoot } from "../../../../../../../../../../components/LightTable";

export const cellProcessing = (item: CommissionCellContent.Props["item"]) => {
	if (!isNumber(item?.executorRate?.commission)) return "";
	return formatNumber(item?.executorRate?.commission);
};

const CommissionCellContent: React.FC<CommissionCellContent.Props> = ({
	item,
}) => {
	const content = useMemo(() => cellProcessing(item), [item]);

	return (
		<CellContentRoot alignItems="center" w="100%" h="100%">
			{content}
		</CellContentRoot>
	);
};

declare namespace CommissionCellContent {
	interface Props {
		item: ExecutorReport.Model;
		language: Language;
	}
}

export default CommissionCellContent;
